import type { IconProps } from './types';

export type ArrowIconProps = {
  direction?: 'up' | 'down' | 'left' | 'right' | 'down-right' | 'down-left' | 'up-right' | 'up-left';
} & IconProps;

export const ArrowIcon = (props: ArrowIconProps) => {
  const {
    width = 18,
    height = 20,
    color = 'currentColor',
    className,
    direction = 'up',
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      className={className}
      style={{
        ...(direction === 'up' && { transform: 'rotate(0deg)' }),
        ...(direction === 'up-right' && { transform: 'rotate(45deg)' }),
        ...(direction === 'right' && { transform: 'rotate(90deg)' }),
        ...(direction === 'down-right' && { transform: 'rotate(135deg)' }),
        ...(direction === 'down' && { transform: 'rotate(180deg)' }),
        ...(direction === 'down-left' && { transform: 'rotate(225deg)' }),
        ...(direction === 'left' && { transform: 'rotate(270deg)' }),
        ...(direction === 'up-left' && { transform: 'rotate(315deg)' }),
      }}
    >
      <path
        fill={color}
        d="M8.24667 18.3567V3.45633L1.816 9.887C1.52311 10.1799 1.04835 10.1799 0.755454 9.887C0.46277 9.59409 0.462631 9.11927 0.755454 8.82645L8.45174 1.13016C8.46855 1.11232 8.48698 1.09649 8.50545 1.08036C8.51664 1.0705 8.52802 1.06111 8.53963 1.05204C8.63119 0.981177 8.73783 0.929908 8.85604 0.907506L8.85799 0.906529C8.90286 0.898158 8.94937 0.892857 8.99667 0.892857L8.99764 0.893834C8.99927 0.893829 9.00089 0.893828 9.00252 0.893834C9.04316 0.894167 9.08282 0.898024 9.12167 0.904576C9.2711 0.929071 9.41458 0.997387 9.52987 1.11258L17.2447 8.82645L17.2965 8.88407C17.5364 9.17854 17.5189 9.6125 17.2447 9.887C16.9701 10.1616 16.5354 10.1792 16.2408 9.93876L16.1842 9.887L9.74667 3.4495V18.3567C9.74667 18.7708 9.41069 19.1065 8.99667 19.1067C8.58245 19.1067 8.24667 18.7709 8.24667 18.3567Z"
      />
    </svg>
  );
};
